export const MARK_NOTIFICATION_AS_READ = '[NOTIFICATIONS] MARK NOTIFICATION AS READ';
export const MARK_ALL_NOTIFICATIONS_AS_READ = '[NOTIFICATIONS] MARK ALL NOTIFICATIONS AS READ';
export const GET_ALL_NOTIFICATIONS = '[NOTIFICATIONS] GET ALL NOTIFICATIONS';
export const GET_UNREAD_FIELDS = '[NOTIFICATIONS] GET UNREAD FIELDS';
